// BusinessForm.tsx

import React from "react";
import CommonTextField from "../../../components/CommonTextField";
import { CountryStateSelect } from "src/features/auth/components/CountryStateSelect";
import { BusinessFormData } from "../hooks/useBusinessForm";

interface BusinessFormProps {
  formData: BusinessFormData;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  phoneError?: string;
}

const BusinessForm: React.FC<BusinessFormProps> = ({ formData, handleChange, setFormData, phoneError }) => {
  const handleCountryChange = (value: string) => {
    setFormData((prev: BusinessFormData) => ({
      ...prev,
      country: value,
      state: "",
    }));
  };

  const handleStateChange = (value: string) => {
    setFormData((prev: BusinessFormData) => ({
      ...prev,
      state: value,
    }));
  };

  return (
    <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
      <CommonTextField label="User Name" name="userName" value={formData.userName} onChange={handleChange} disabled />

      <CommonTextField label="Name" name="firstName" value={formData.firstName} onChange={handleChange} />

      <CommonTextField label="Organization Name" name="orgName" value={formData.orgName} onChange={handleChange} disabled />

      <CommonTextField label="Organization Arabic Name" name="arabicName" value={formData.arabicName} onChange={handleChange} />

      <CommonTextField label="Business Type" name="businessType" value={formData.businessType} onChange={handleChange} disabled />

      <CommonTextField label="Email ID" name="email" type="email" value={formData.emails?.[0]?.email || ""} onChange={handleChange} />

      <CommonTextField label="Date of Birth" name="dob" type="date" value={formData.dob || ""} onChange={handleChange} />

      <CommonTextField
        label="Phone Number"
        name="phone"
        value={formData.phones?.[0]?.phone || ""}
        onChange={handleChange}
        error={!!phoneError || !!(formData.phones?.[0]?.phone && formData.phones?.[0]?.phone.length !== 8)}
        helperText={phoneError || (formData.phones?.[0]?.phone && formData.phones?.[0]?.phone.length !== 8 ? "Phone number must be exactly 8 digits" : "")}
      />

      <div className="md:col-span-2">
        <CommonTextField label="Address" name="addressLine1" value={formData.addressLine1} onChange={handleChange} fullWidth multiline rows={2} />
      </div>

      <CommonTextField label="Business Location" name="businessLocation" value={formData.businessLocation} onChange={handleChange} />

      <CommonTextField label="Time Zone" name="timeZone" value={formData.timeZone || ""} onChange={handleChange} />

      <div className="md:col-span-2">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
          <CountryStateSelect selectedCountry={formData.country} selectedState={formData.state} onCountryChange={handleCountryChange} onStateChange={handleStateChange} hideWrapper={true} />

          <div>
            <CommonTextField label="Postal Code" name="postalCode" value={formData.postalCode} onChange={handleChange} fullWidth style={{ marginTop: "20px" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessForm;
